<template>
  <div id="fileList" class="page message-list-page">
    <!-- 文件 -->
    <div class="search-container">
      <div>
        <page-title page-name="文件" icon="iconfont icon-wenjian" :showTabs="false" />
        <div v-show="activeSearchName">"{{ activeSearchName }}"中的搜索结果：</div>
        <el-breadcrumb separator="/" v-show="!activeSearchName && filePaths.length > 1">
          <el-breadcrumb-item v-show="filePaths.length">
            <span @click.stop="goBackFolder" class="return-to-upper-level">
              <i class="iconfont icon-gongnenglei_fanhui" />
              <span>返回上一级</span>
            </span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="item in filePaths" :key="item.id" :title="item.name">{{ truncatedFilePaths(item.name, 8) }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-line">
        <div>
          <el-input
            v-model="searchForm.keyword"
            class="keyword-input"
            clearable
            placeholder="搜索名称"
            @change="()=>keywordChange()"
          >
            <i slot="append" class="el-icon-search" />
          </el-input>
          <el-popover
            title="筛选器"
            placement="bottom-end"
            v-model="sizerPopoverVisible"
            width="430"
          >
            <div class="sizer-content">
              <div class="label-content">
                <span>类型：</span>
              </div>
              <div class="sizer-main-content">
                <span class="sizer-box">
                  <el-tag v-for="(item, index) in  tags" :key="index" :class="activeSizerTagIndex.includes(index) && 'active-tag'" @click.stop="sizerTagClick(index)">{{ item }}</el-tag>
                </span>
              </div>
            </div>
            <el-button slot="reference" icon="el-icon-files" class="sizer-btn">筛选器</el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="sizer-view-container" v-show="selectSizerTags.length">
      <label>筛选：</label>
      <el-tag type="info" v-for="(item, index) in selectSizerTags" :key="index" closable @close="handleCloseTag(item)">{{ item }}</el-tag>
      <span @click.stop="sizerInitializeClick()">清空</span>
    </div>
    <div class="content-container">
      <div class="flex-1">
        <gjw-list-page-layout>
          <template #leftBox>
            <div class="folder-catalog">
              <ClassifyTreeV2
              TYPE="FILE"
              ref="classifyTree"
              :tree-data="fileTreeList"
              :list-data.sync="tableData"
              :customIcon="true"
              :expandOnClickNode="true"
              :editable="true"
              :expanded-keys="defaultKeyArr"
              @tree-node-click="treeNodeClick"
              @node-expand="treeNodeExpand"
              @node-collapse="treeNodeCollapse"
              @handleRename="updateAllData"
              @updateListData="updateAllData"
              @handleMove="handleMove"
              @handleDelete="deleteFile"
              @setPermission="setPermission"
              @stopPolling="stopPolling"
              @startPolling="startPolling(polling)"
            />
            </div>
          </template>
          <!-- 批量操作 -->
          <template #btnBox>
            <div class="btn-left">
              <div class="operations-left">
                <el-popover
                  width="200"
                  placement="bottom-start"
                  v-model="createFolderVisible"
                >
                  <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
                    <el-form-item prop="fileName">
                      <el-input v-model="ruleForm.fileName" :maxlength="30" placeholder="请输入文件夹名称"/>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 10px 0 0 0">
                    <el-button size="mini" @click.stop="cancelContentFiles">取消</el-button>
                    <el-button type="primary" size="mini" @click.stop="createContentFiles">确定</el-button>
                  </div>
                  <el-button slot="reference" type="primary" icon="el-icon-plus" :disabled="!!activeSearchName && !!searchForm.keyword || hasPermission(activePermissionType, 'FOLDER_CREATE')">新建文件夹</el-button>
                </el-popover>
                <el-button type="primary" icon="iconfont icon-wenjian-shangchuan" :disabled="!!activeSearchName && !!searchForm.keyword || hasPermission(activePermissionType, 'FILE_UPLOAD')" @click.stop="showUploader('upload')">上传文件</el-button>
                <el-dropdown>
                  <el-button type="primary">
                    合模<i class="el-icon-caret-bottom el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.stop.native="toCreatePlan"><span>新建合模方案</span></el-dropdown-item>
                    <el-dropdown-item @click.stop.native="toViewPlan"><span>查看所有合模</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-if="selectedList.length" class="batch-button-box">
                <el-button icon="iconfont icon-wenjian-xiazai" plain @click.stop="batchDownload">下载</el-button>
                <el-button icon="iconfont icon-yidong" plain @click.stop="openClassifyDialog">移动</el-button>
                <el-button icon="iconfont icon-wenjian-shanchu" :class="{'delete-button' : !!selectedList.length}" plain @click.stop="batchDeleteFiles">删除</el-button>
              </div>
              <div v-else class="batch-button-box">
                <el-tooltip content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-wenjian-xiazai" /><span>下载</span></span>
                </el-tooltip>
                <el-tooltip content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-yidong" /><span>移动</span></span>
                </el-tooltip>
                <el-tooltip content="请先勾选操作对象" placement="bottom">
                  <span class="disabled-button"><i class="iconfont icon-wenjian-shanchu" /><span>删除</span></span>
                </el-tooltip>
              </div>
            </div>
            <div class="btn-right">
              <span>共 {{ dataTotal }} 个内容</span>
              <el-button
                type="text"
                icon="el-icon-refresh-right"
                title="刷新"
                class="refresh-btn"
                @click.stop="handleRefresh(true)"
              />
            </div>
          </template>
          <template #tableBox>
            <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="selectTableData"
              :has-page="false"
              :row-class-name="rowClassName"
              @table-selection-change="selectionChange"
              @sort-change="sortChange"
              @row-dblclick="rowDblclick"
            >
              <template #nameSlot="{ row, index }">
                <edit-input
                  v-if="modifyIndex === index && modifyCol === 'name'"
                  @click.stop.native
                  ref="editName"
                  :maxlength="30"
                  :init-value="tempRow.name"
                  @edit-confirm="(value)=>modifyName(row, value)"
                  @edit-cancel="resetModify"
                />
                <span v-else class="table-name">
                  <img v-if="row.isFolder" class="iconfont icon-wenjianjia-gongkai folder-img" src="~@/assets/img/wenjianjia.png" style="margin-right: 6px;" alt="" />
                  <img v-else class="file-img" :src="getFileIcon(row.suffix)" style="margin-right: 6px;" alt="" />
                  <span
                      v-html="row.displayName"
                      :class="{'name-click': (has3DFileTypes.includes(row.fileType) && row.bimfaceTranslateStatus==='SUCCESS')}"
                      @click.stop="toView(row)"
                  ></span>
                  <el-tooltip v-show="row.parseStatus === 'PROCESSING'" content="正在解析文件的软件及版本" placement="top">
                    <i class="el-icon-loading table-cell-icon" />
                  </el-tooltip>
                  <el-tooltip v-show="row.parseStatus === 'FAILED'" placement="top">
                    <div slot="content">软件及版本解析失败，但您仍可使用该文件。<br/>如需重新解析请删除后重新上传。</div>
                    <i class="el-icon-question table-cell-icon" />
                  </el-tooltip>
                </span>
              </template>
              <template #pathSlot="{row}">
                <!-- <a class="full-file-paths" @click.stop="quitSearchStatus">{{ fullFilePaths }}</a> -->
                <div @click.stop @dbclick.stop>
                  <a class="full-file-paths"  @click.stop="goToFolder(row)">{{ row.isFolder ? '/' : '定位到所在文件夹' }}</a>
                </div>
              </template>
              <template #modelLabelSlot>
                <span style="margin-right: 3px;">轻量化模型</span>
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">仅支持当前启用版本文件</div>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
              <template #modelSlot="{ row, index }">
                <div v-if="!row.isFolder && has3DFileTypes.includes(row.fileType)" class="flex">
                  <el-tooltip v-if="row.bimfaceTranslateStatus === 'PROCESSING'" effect="dark" content="正在转换中，请稍候" placement="bottom-start">
                    <img src="../../assets/img/icon_zhuanhuanzhong.png" />
                  </el-tooltip>
                  <div v-else class="model-status">
                    <el-dropdown placement="bottom-start">
                      <div class="el-dropdown-link link-content">
                        <img v-if="!row.bimfaceTranslateStatus || row.bimfaceTranslateStatus === 'PREPARE'" src="../../assets/img/icon_weizhuanhuan.png" alt="" />
                        <img v-if="row.bimfaceTranslateStatus === 'FAILED'" src="../../assets/img/icon_zhuanhuanshibai.png" alt="" />
                        <img v-if="row.bimfaceTranslateStatus === 'SUCCESS'" src="../../assets/img/icon_zhuanhuanchenggong.png" alt="" />
                        <i class="el-icon-caret-bottom"></i>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="!row.bimfaceTranslateStatus || row.bimfaceTranslateStatus === 'PREPARE'" @click.stop.native="translateModel(row, index)"><span>轻量化转换</span></el-dropdown-item>
                        <el-dropdown-item v-if="row.bimfaceTranslateStatus === 'FAILED'" @click.stop.native="translateModel(row, index)"><span>重新转换</span></el-dropdown-item>
                        <el-dropdown-item v-if="row.bimfaceTranslateStatus === 'SUCCESS'" @click.stop.native="toView(row)"><span>查看</span></el-dropdown-item>
                        <el-dropdown-item v-if="row.bimfaceTranslateStatus === 'SUCCESS'" @click.stop.native="toShare(row)"><span>分享</span></el-dropdown-item>
                        <el-dropdown-item
                            v-if="row.bimfaceTranslateStatus === 'SUCCESS'"
                            @click.stop.native="toOffline(row)"
                            :disabled="row.offlinePackageStatus === 'PROCESSING'"
                        >
                          <span>生成离线包</span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <div v-if="row.bimfaceTranslateStatus === 'SUCCESS'" class="offline-status">
                      <el-tooltip v-show="row.offlinePackageStatus === 'PROCESSING'" effect="dark" placement="bottom">
                        <div slot="content">正在生成离线包</div>
                        <i class="el-icon-loading ft-icon"></i>
                      </el-tooltip>
                      <el-tooltip v-show="row.offlinePackageStatus === 'SUCCESS'" effect="dark" placement="bottom">
                        <div slot="content">点击下载</div>
                        <img src="@/assets/img/offline-package.png" width="20" style="margin-top: 2px;" @click="downloadOffline(row)" />
                      </el-tooltip>
                      <el-tooltip v-show="row.offlinePackageStatus === 'FAILED'" effect="dark" placement="bottom">
                        <div slot="content">离线包生成失败，请重新生成。</div>
                        <i class="iconfont icon-tongyong_warning-2 ft-yellow ft-icon"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>
              <template #fileTypeSlot="{ row }">
                <span>{{ row.fileType || '--' }} </span>
              </template>
              <template #lengthSlot="{ row }">
                <span>{{ row.length ? formatSize(row.length, 1) : '--' }} </span>
              </template>
              <template #operateSlot="{ row , index}">
                <div @click.stop @dbclick.stop>
                  <el-button v-if="!row.isFolder && clientType ==='web'" type="text" :disabled="hasPermission(row.permissionType, row.isFolder ? 'FOLDER_DOWNLOAD' : 'FILE_DOWNLOAD')" @click.stop.native="toDownload(row)">下载</el-button>
                  <el-button v-if="!row.isFolder && (!showLink(row) && !showImport(row))" type="text" :disabled="hasPermission(row.permissionType, 'FILE_UPDATE')" @click.stop="onRenewal(row, 'renewal')">更新</el-button>
                  <el-button v-if="showLink(row)" type="text" :disabled="hasPermission(row.permissionType, 'FILE_LINK')" @click.stop="onLink(row)">链接</el-button>
                  <el-button v-if="showImport(row)" type="text" :disabled="hasPermission(row.permissionType, 'FILE_IMPORT')" @click.stop="onImport(row)">导入</el-button>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more ft-theme"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="!row.isFolder && (showLink(row) || showImport(row))" :disabled="hasPermission(row.permissionType, 'FILE_UPDATE')" @click.stop.native="onRenewal(row, 'renewal')">更新</el-dropdown-item>
                      <el-dropdown-item v-if="!row.isFolder" :disabled="hasPermission(row.permissionType, 'FILE_DETAIL')" @click.stop.native="showDataVersionRecord(row)">版本管理</el-dropdown-item>
                      <el-dropdown-item @click.stop.native="setPermission(row)">权限</el-dropdown-item>
                      <el-dropdown-item v-if="!row.isFolder && clientType !=='web'" :disabled="hasPermission(row.permissionType, row.isFolder ? 'FOLDER_DOWNLOAD' : 'FILE_DOWNLOAD')" @click.stop.native="toDownload(row)">下载</el-dropdown-item>
                      <el-dropdown-item :disabled="hasPermission(row.permissionType, row.isFolder ? 'FOLDER_RENAME' : 'FILE_RENAME')" @click.stop.native="cellClick(row,index, 'name')">重命名</el-dropdown-item>
                      <!-- <el-dropdown-item @click.stop.native="openClassifyDialog(row)">移动</el-dropdown-item> -->
                      <el-dropdown-item :class="!hasPermission(row.permissionType, row.isFolder ? 'FOLDER_DELETE':'FILE_DELETE') && 'delete'" :disabled="hasPermission(row.permissionType, row.isFolder ? 'FOLDER_DELETE':'FILE_DELETE')" @click.stop.native="deleteFile(row)">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </gjw-table>
          </template>
          <template #footerBox>
            <file-uploader
              ref="uploader"
              class="component-uploader"
              :resource-type="resourceType"
              :allow-types="allowFileType()"
              :platform="null"
              :software-code="clientTypeSoftwareCode"
              :software-version="clientTypeSoftwareVersion"
              :space-category-id="spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : fileTreeList[0]?.id"
              :space-classify-tree="fileTreeList"
              :renewal-obj="renewalObj"
              @success="uploadCallback"
            />
          </template>
        </gjw-list-page-layout>
      </div>
      <!--移动-->
      <gjw-dialog
        :show-dialog="showClassifyDialog"
        class="ClassifyDialog"
        :title="typeName"
        @close="closeClassifyDialog"
        @confirm="() => { confirmModifyClassify(batchClassifyValue); }">
        <classifySelectV2
          ref="classifySelectDialog"
          :customIcon="true"
          :tree-data="fileTreeList"
          :expanded-keys="[fileTreeList[0]?.id]"
          @tree-node-click="chooseBatchClassify"
        />
      </gjw-dialog>
      <!-- 轻量化转换 -->
      <gjw-dialog
          :show-dialog="showTranslateModelDialog"
          title="轻量化转换"
          :config="{ width:'540px', class: 'has-footer-border body-no-padding', confirmText: '开始转换'}"
          :confirm-loading="translateLoading"
          @close="closeTranslateModelDialog"
          @confirm="startTranslate">
        <div>
          <div class="tip-line">
            <i class="iconfont icon-tishi ft-theme mg-rt-md"></i>
            <span>每个版本仅支持转换一次，请谨慎操作，更新文件版本后需重新转换。</span>
          </div>
          <div class="model-body">
            <div class="content-line mg-bt-md">
              <span class="">文件名称：</span>
              <ellipsis-text
                  :text="translateModelFileInfo.suffix ? `${translateModelFileInfo.fileName}.${translateModelFileInfo.suffix}`:`${translateModelFileInfo.fileName || ''}`"
              ></ellipsis-text>
              <span class="version-tag">{{ translateModelFileInfo.version }}</span>
            </div>
            <div v-if="translateModelFileInfo.fileType === 'RVT'" class="content-line">
              <span class="">显示效果：</span>
              <el-radio v-model="texture" :label="false">着色</el-radio>
              <el-radio v-model="texture" :label="true">真实</el-radio>
            </div>
          </div>
        </div>
      </gjw-dialog>
      <!-- 确认生成离线包 -->
      <gjw-dialog
          :show-dialog="showOfflineComfirm"
          :config="{width: '400px', class: 'no-header', showClose: false, confirmText: '开始生成'}"
          @close="showOfflineComfirm = false"
          @confirm="generateOfflinePackage"
      >
        <div class="confirm-main">
          <i class="el-icon-warning confirm-icon ft-theme" />
          <div class="confirm-text">
            <div class="main-text">是否确认生成离线包？</div>
            <div class="sub-text">可能会耗费一定时间，请耐心等待。</div>
          </div>
        </div>
        <div></div>
      </gjw-dialog>
      <!-- 分享轻量化模型 -->
      <model-share-dialog ref="ModelShareDialog" share-type="FILE_REVISION" @share-link-opened='shareTrack' />
      <!-- 数据版本记录 -->
      <data-version-record ref="dataVersionRecordDrawer" direction="ltr" @version-changed="showDataVersionRecord" @onLink="onLink" @onImport="onImport"/>
      <!-- 链接 -->
      <revit-link-RVT ref="revitLinkRVT" />
      <revit-link-CAD ref="revitLinkCAD" />
      <link-ifc ref="linkIFC" />
      <!-- 导入 -->
      <revit-import ref="revitImport" />
      <g-import ref="gImport" />
      <!-- 权限 -->
      <edit-permission-dialog ref="editPermissionDialogRef" type="FILE" :dialog-visible="editPermissionDialogVisible" :subTitle="permissionSubTitle" @close="editPermissionDialogVisible = false" @success="setPermissionSuccess"/>
      <create-edit-plan ref="CreateEditPlanDialog" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Dict from '@/core/dict'
import Utils from '@/core/utils'
import Tools from '@/core/tools'
import permissionMixin from '@/mixins/permissionMixin.js'
import openUrlMixin from '@/mixins/openUrlMixin'
import pollingMixin from '@/mixins/pollingMixin'
import {
  fileErrorCodeMap,
  listErrorCodeMap,
  newErrorCodeMap,
  moveErrorCodeMap,
  renameErrorCodeMap,
  deleteErrorCodeMap,
  batchDeleteErrorCodeMap,
  versionRecordsErrorCodeMap,
  downloadErrorCodeMap,
  batchDownloadErrorCodeMap,
} from './errorCodeMap'
import { RegSymbol } from '@/core/RegExp'
import PageTitle from '@/components/business/PageTitle.vue'
import EditInput from '@/components/business/EditInput.vue'
import classifySelectV2 from '@/components/business/resource/classifySelectV2.vue'
import ClassifyTreeV2 from '@/components/business/resource/ClassifyTreeV2.vue'
import FileUploader from './components/FileUploader.vue'
import EditPermissionDialog from '@/components/business/EditPermissionDialog'
import Queue from '@/core/queue'
import { businessBasePath } from '@/core/desktopCache'
import { getFileTypes } from '@/assets/js/resourceMap.js'
import resourceOperations from '@/mixins/resourceOperations'
import DataVersionRecord from './components/DataVersionRecord.vue'
import RevitLinkCAD from './link/RevitLinkCAD'
import RevitLinkRVT from './link/RevitLinkRVT'
import LinkIfc from './link/LinkIFC.vue'
import RevitImport from './import/RImport.vue'
import GImport from './import/GImport.vue'
import EllipsisText from './components/EllipsisText.vue'
import CreateEditPlan from './components/CreateEditPlan.vue'
import ModelShareDialog from '@/views/file/components/ModelShareDialog.vue'
import { eventBus } from '@/core/eventBus'

export default {
  name: 'FileList',
  props: {
    prop: {
      type: Object,
    },
    activeName: {
      type: String,
    },
  },
  components: {
    ModelShareDialog,
    PageTitle,
    ClassifyTreeV2,
    EditInput,
    FileUploader,
    classifySelectV2,
    DataVersionRecord,
    RevitLinkRVT,
    RevitLinkCAD,
    LinkIfc,
    RevitImport,
    GImport,
    EllipsisText,
    EditPermissionDialog,
    CreateEditPlan,
  },
  mixins: [resourceOperations, permissionMixin, openUrlMixin, pollingMixin],
  data() {
    var validateSpecialChar = (rule, value, callback) => {
      if (!value) return
      if (value.includes('\\') || value.includes('/') || value.includes(':') || value.includes('*') ||
          value.includes('<') || value.includes('>') || value.includes('|') || value.includes('?')) {
        callback(new Error('不能包含特殊字符：\\ /:*<>|?'))
      } else {
        callback()
      }
    }
    return {
      firstEnter: true,
      tags: [],
      selectSizerTags: [],
      has3DFileTypes: ['GAP', 'GMEP', 'GST', 'GAPC', 'GMEPC', 'GSTC', 'RVT', 'NWD', 'IFC', 'IFCZIP'],
      sizerPopoverVisible: false,
      activeSizerTagIndex: [],
      filePaths: [],
      // 构件的资源类型
      resourceType: 'FILE',
      searchForm: {},
      sortForm: {},
      statusOpts: Dict.statusOptionsAll,
      tableData: [],
      folderData: [],
      selectTableData: [],
      newRows: [], // 记录新上传的文件，用于高亮显示
      isFirstChange: true, // 标记selectTableData是否为第一次变化
      tableLoading: false,
      modifyIndex: -1, // 当前要修改的行序
      modifyCol: '', // 当前要修改的col
      tempRow: {}, // 备份要修改的row
      showClassifyDialog: false,
      batchClassifyValueDisable: true, // 修改分类弹窗的确定按钮是否可点击
      batchClassifyValue: false,
      dataTotal: 0,
      renewalObj: {},
      crQueue: new Queue(5, this.createNewFile), // 创建队列实例
      reQueue: new Queue(5, this.renewalFile), // 更新队列实例
      spaceId: this.$route.params.spaceId,
      activeVersionRecordsId: '',
      spaceResourceId: '',
      spaceCategoryIdMove: '',
      typeName: '移动到',
      availableResource: false,
      spaceCategoryId: null,
      fileTreeList: [],
      selectFolderId: '',
      createFolderVisible: false,
      activeSearchName: '',
      ruleForm: {
        fileName: ''
      },
      rules: {
        fileName: [
          { required: true, message: '请输入文件夹名称', trigger: 'blur' },
          { validator: validateSpecialChar, trigger: 'change' },
          { validator: this.customValidate, trigger: 'blur' }
        ],
      },
      activeApiCode: '', // 当前接口状态码
      linkObject: null,
      editPermissionDialogVisible: false,
      permissionSubTitle: '',
      activePermissionType: '',
      defaultKeyArr: [],
      currentCatalog: {},
      // 当前显示的轻量化菜单行数
      showModelMenu: false,
      hoverRowId: '',
      showTranslateModelDialog: false,
      translateLoading: false,
      translateModelFileInfo: {},
      // 着色效果设置
      texture: false,
      showOfflineComfirm: false,
      generateRow: {},
    }
  },
  watch: {
    createFolderVisible(val) {
      if (!val) {
        this.$refs.ruleForm.resetFields()
      }
    },
    sizerPopoverVisible() {
      if (this.selectSizerTags.length) {
        this.activeSizerTagIndex = this.selectSizerTags.map((tag) => this.tags.findIndex((t) => t === tag))
      } else {
        this.activeSizerTagIndex = []
      }
    },
    selectTableData(newValue, oldValue) {
      // 第一次加载页面不监听变化
      if (this.isFirstChange) {
        this.isFirstChange = false
        return
      }
      if (newValue.length === oldValue.length) return
      const oldIds = new Set(oldValue.map((item) => item.id))
      this.newRows.push(...newValue.filter((item) => !oldIds.has(item.id) && !item.isFolder))
    },
  },
  computed: {
    ...mapGetters({
      spacePlatClassify: 'classifySpace/spacePlatClassify',
      getSpaceRootNode: 'classifySpace/getRoot',
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      clientType: 'platform',
      isCapitalSoftware: 'isCapitalSoftware',
      pluginCachePath: 'pluginCachePath',
      canUpdateCachePath: 'canUpdateCachePath',
      canEmitWebEventToDesktop: 'canEmitWebEventToDesktop'
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'selection',
          width: '48px',
          selectable: () => {
            return !this.activeSearchName
          },
          attrs: {
            align: 'center',
          },
        },
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          sortable: 'custom',
          minWidth: '140px',
        },
        // 轻量化模型
        {
          type: 'slot',
          slotName: 'modelSlot',
          labelSlotName: 'modelLabelSlot',
          showOverflowTooltip: false,
          prop: 'model',
          width: '96px',
        },
        {
          type: 'slot',
          slotName: 'pathSlot',
          label: '存储路径',
          prop: 'path',
          minWidth: '160px',
          showFn: () => {
            return !!this.activeSearchName && this.searchForm.keyword
          }
        },
        {
          label: '创建时间',
          prop: 'createTime',
          sortable: 'custom',
          minWidth: '96px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新时间',
          prop: 'lastModifiedTime',
          sortable: 'custom',
          minWidth: '96px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新人',
          prop: 'lastModifierName',
          minWidth: '90px'
        },
        {
          type: 'slot',
          label: '类型',
          slotName: 'fileTypeSlot',
          prop: 'fileType',
          sortable: 'custom',
          minWidth: '68px'
        },
        {
          type: 'slot',
          slotName: 'lengthSlot',
          label: '大小',
          prop: 'length',
          minWidth: '68px'
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          minWidth: '110px'
        },
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    rootNode() {
      return this.getSpaceRootNode
    },
    uploaderSpaceClassifyId() {
      // 默认的上传至
      const spaceCategoryId = this.spaceCategoryId
      const results = spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : this.rootNode.id
      console.log(results)
      return results
    },
    truncatedFilePaths() {
      return (name, maxLength) => {
        return Utils.truncateString(name, maxLength)
      }
    },
    fullFilePaths() {
      const names = this.filePaths.map((item) => item.name)
      names.unshift('全部文件')
      return names.join('/')
    },
    formatSize() {
      return (sizeBytes, toFixed) => Tools.fmtSize(sizeBytes, toFixed)
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    }
  },
  created() {
    this.firstEnter = true
    // 获取空间ID
    this.init()
    this.getFileTypeTags()
    this.selectFolderId = this.fileTreeList[0]?.id
    this.spaceCategoryId = this.fileTreeList[0]?.id
    this.startPolling(this.polling)
  },
  mounted() {
    window.addEventListener('click', this.handleClick)
    console.info('before emitting event to eventBus: file-list-comp-ready')
    eventBus.$emit('file-list-comp-ready', this)
    console.info('after emitting event to eventBus: file-list-comp-ready')
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleClick)
  },
  methods: {
    ...mapActions({
      checkFeedbackExists: 'feedback/checkFeedbackExists',
    }),
    handleClick() {
      this.$nextTick(() => {
        this.newRows = []
      })
    },
    showLink(row) {
      if (this.clientType === 'web') {
        return false
      }
      const rUsableFileTypes = ['RVT', 'DWG', 'DXF']
      const gUsableFileTypes = ['GAP', 'GMEP', 'GST', 'GAPC', 'GMEPC', 'GSTC', 'IFC', 'IFCZIP']
      const capUsableFileTypes = ['GMC']
      const usableFileTypes = this.isCapitalSoftware ? capUsableFileTypes : this.clientType === 'g' ? gUsableFileTypes : this.clientType === 'r' ? rUsableFileTypes : []
      return usableFileTypes.includes(row.fileType)
    },
    showImport(row) {
      if (this.clientType === 'web') {
        return false
      }
      const usableFileTypes = ['DWG', 'DXF']
      return usableFileTypes.includes(row.fileType)
    },
    async init() {
      await this.getFolderData()
      this.selectFolderId = this.fileTreeList[0]?.id
      await this.getList({ parentId: this.fileTreeList[0]?.id }, !this.firstEnter)
      if (this.firstEnter) {
        this.firstEnter = false
      }
    },
    getFileTypeTags() {
      this.$api.file.fileTypeTags(this.spaceId).then((res) => {
        this.tags = res || []
      })
    },
    cancelContentFiles() {
      this.ruleForm.fileName = ''
      this.createFolderVisible = false
    },
    async createContentFiles() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (!this.selectFolderId) {
            this.$message.warning('请选择文件夹要存放的位置')
            return
          }
          await this.$api.file.getFilePath(this.spaceId, this.selectFolderId)
          const params = {
            isFolder: true,
            name: this.ruleForm.fileName,
            parentId: this.selectFolderId
          }
          try {
            await this.$api.file.createFile(this.spaceId, params)
            this.activeApiCode = ''
            this.$tracks({
              event: 'newProfileFolder',
              params: { g_c_space_id: this.spaceId, }
            })
            this.createFolderVisible = false
            this.$message.success('新建成功')
            this.ruleForm.fileName = ''
            await this.updateAllData()
            const activeLevel = this.getLevelFile(1)
            this.activePermissionType = activeLevel.permissionType
          } catch (err) {
            if (err.code) {
              this.activeApiCode = err.code
              this.$refs.ruleForm.validateField('fileName')
            }
          }
        } else {
          return false
        }
      })
    },
    // 新建-重名校验
    customValidate(rule, value, callback) {
      let errorFound = false
      for (const key in newErrorCodeMap) {
        if (Object.prototype.hasOwnProperty.call(newErrorCodeMap, key)) {
          if (this.activeApiCode === key) {
            this.activeApiCode = ''
            callback(new Error(newErrorCodeMap[key]))
            errorFound = true
            break
          }
        }
      }
      if (!errorFound) {
        callback()
      }
    },
    sizerTagClick(index) {
      this.isFirstChange = true
      // 取消选中
      if (this.activeSizerTagIndex.length && this.activeSizerTagIndex.includes(index)) {
        this.activeSizerTagIndex = this.activeSizerTagIndex.filter((item) => item !== index)
        this.sizerConfirmBtnClick()
        return
      }
      // 选中
      this.activeSizerTagIndex.push(index)
      this.sizerConfirmBtnClick()
    },
    sizerInitializeClick() {
      this.isFirstChange = true
      this.selectSizerTags = []
      this.search({ fileTypes: this.selectSizerTags }, false, true)
      this.activeSizerTagIndex = []
    },
    sizerConfirmBtnClick() {
      const activeLevel = this.getLevelFile(1)
      this.selectSizerTags = this.activeSizerTagIndex.map((key) => this.tags[key])
      if (this.selectSizerTags.length || !this.activeSizerTagIndex.length) {
        this.getList({ parentId: activeLevel?.id }, true)
        this.selectSizerTags.length && this.$message.success('筛选生效')
      }
    },
    handleCloseTag(tag) {
      this.isFirstChange = true
      const activeLevel = this.getLevelFile(1)
      const delTagIndex = this.tags.indexOf(tag)
      this.activeSizerTagIndex = this.activeSizerTagIndex.filter((item) => item !== delTagIndex)
      this.selectSizerTags = this.selectSizerTags.filter((item) => item !== tag)
      this.getList({ parentId: activeLevel?.id }, true)
    },
    async setPermission({ id, path, isFolder, name, suffix }) {
      await this.$api.file.getFilePath(this.spaceId, id)
      if (this.$route.name === 'File') {
        if (isFolder) {
          this.permissionSubTitle = `文件夹名称：${name}`
        } else {
          this.permissionSubTitle = `文件名称：${name}.${suffix}`
        }
      }
      const object_type = isFolder ? 'FOLDER' : 'FILE'
      this.$refs.editPermissionDialogRef?.init({ id, path }, object_type)
      this.editPermissionDialogVisible = true
    },
    setPermissionSuccess() {
      // 文件和目录权限
      this.$tracks({ event: 'modifyFilePermission', params: { g_c_space_id: this.spaceId }})
      this.search()
    },
    async showDataVersionRecord(row, type) {
      // 文件版本记录，弹框评分
      this.checkFeedbackExists().catch()
      try {
        if (type === 'refreshList') {
          await this.handleRefresh()
        }
        row?.id && (this.activeVersionRecordsId = row.id)
        const data = await this.$api.file.getVersionRecords(this.spaceId, this.activeVersionRecordsId)
        if (data) {
          this.$refs.dataVersionRecordDrawer?.openDrawer(data, this.spaceId, row, { isShowLink: this.showLink(row), isShowImport: this.showImport(row) })
        }
      } catch (err) {
        this.$matchError(err.code, versionRecordsErrorCodeMap)
      }
    },
    isAvailableROperation(item) {
      return this.platform === 'r' && item.status === ''
    },
    isAvailableGOperation() {
      return this.platform === 'web'
    },
    treeNodeClick(node) {
      this.isFirstChange = true
      this.activePermissionType = node.permissionType
      this.selectFolderId = node.id
      !this.defaultKeyArr.includes(node.id) && this.defaultKeyArr.push(node.id)
      this.updateHighlightNode(this.selectFolderId)
      this.getFilePath(node)
      this.resetSelectedClassify()
      this.quitSearchStatus(true)
      this.spaceCategoryId = node.id
    },
    async treeNodeExpand(node) {
      // await this.treeNodeClick(node)
    },
    treeNodeCollapse(node) {
      if (this.defaultKeyArr.includes(node.id)) {
        this.defaultKeyArr = this.defaultKeyArr.filter((item) => item !== node.id)
      }
    },
    handleMove(data) {
      this.currentCatalog = data
      this.openClassifyDialog(data)
    },
    goBackFolder() {
      this.isFirstChange = true
      // 获取上一层级
      const upOneLevel = this.getLevelFile(2)
      if (upOneLevel) {
        this.selectFolderId = upOneLevel?.id
        this.updateHighlightNode(this.selectFolderId)
        this.getFilePath(upOneLevel)
        this.getList({ parentId: upOneLevel?.id })
        return
      }
      this.filePaths = []
      this.quitSearchStatus()
    },
    // 轻量化转换
    async translateModel(row, index) {
      try {
        const data = await this.$api.file.enableRevision(this.spaceId, row.id)
        if (data.fileRevisionId) {
          this.translateModelFileInfo = { ...data, suffix: row.suffix, fileType: row.fileType, rowIndex: index }
          this.showTranslateModelDialog = true
        }
      } catch (e) {
        this.$matchError(e.code, fileErrorCodeMap, '轻量化转换失败')
      }
    },
    closeTranslateModelDialog() {
      this.showTranslateModelDialog = false
      this.translateLoading = false
      this.texture = false
      this.translateModelFileInfo = {}
    },
    async startTranslate() {
      try {
        this.translateLoading = true
        const params = this.translateModelFileInfo.fileType === 'RVT' ? { texture: this.texture } : {}
        await this.$api.file.translate(this.spaceId, this.translateModelFileInfo.fileId, params)
        const rowIndex = this.translateModelFileInfo.rowIndex
        const rowInfo = this.selectTableData[rowIndex]
        rowInfo.bimfaceTranslateStatus = 'PROCESSING'
        this.selectTableData.splice(rowIndex, 1, rowInfo)
        this.$tracks({
          event: 'translateToBIMFace',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: this.translateModelFileInfo.fileId,
          }
        })
        this.closeTranslateModelDialog()
      } catch (e) {
        this.translateLoading = false
        this.$matchError(e.code, fileErrorCodeMap, '轻量化转换失败')
      }
    },
    // 查看
    async toView(row) {
      // 文件更新，弹框评分
      this.checkFeedbackExists().catch()
      try {
        if (this.has3DFileTypes.includes(row.fileType) && row.bimfaceTranslateStatus === 'SUCCESS') {
          const data = await this.$api.file.enableRevision(this.spaceId, row.id)
          if (data.fileRevisionId) {
            // 跳转到查看页
            this.$tracks({
              event: '3DViewSpaceProfile',
              params: {
                g_c_space_id: this.spaceId,
                g_c_file_id: data.fileId,
              }
            })
            const ModelViewPage = this.$router.resolve({
              name: 'FileModelView',
              params: { spaceId: this.spaceId, fileId: row.id },
              query: {
                fileVersionId: data.fileRevisionId,
                title: data.fileSuffix ? `${data.fileName}.${data.fileSuffix}` : data.fileName,
                version: data.version
              },
            })
            const url = `${process.env.VUE_APP_PROJECT_HOST}${ModelViewPage.href}`
            if (this.clientType === 'web') {
              window.open(url, '_blank')
            } else {
              const webUrl = await this.$api.user.ssoUrl({ dest: url })
              await this.$desktopClient.NavigateToBrowser(webUrl)
            }
          }
        }
      } catch (e) {
        this.$matchError(e.code, fileErrorCodeMap)
      }
    },

    // 去分享
    async toShare(row) {
      try {
        if (this.has3DFileTypes.includes(row.fileType) && row.bimfaceTranslateStatus === 'SUCCESS') {
          const fileInfo = await this.$api.file.enableRevision(this.spaceId, row.id)
          if (fileInfo.fileRevisionId) {
            this.$refs.ModelShareDialog?.openDialog(row).catch()
          }
        }
      } catch (e) {
        this.$matchError(e.code, fileErrorCodeMap, '分享失败')
      }
    },
    shareTrack(shareModelFileInfo) {
      this.$tracks({
        event: 'shareSpaceProfile3D',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: shareModelFileInfo.fileId,
        }
      })
    },
    // 生成离线包
    toOffline(row) {
      this.generateRow = { ...row }
      this.showOfflineComfirm = true
    },
    generateOfflinePackage() {
      this.showOfflineComfirm = false
      const row = this.generateRow
      this.$api.file.createFileOfflinePackage(this.spaceId, row.id, row.spaceFileRevisionId).then(() => {
        const rowIndex = this.selectTableData.findIndex((row) => row.id === this.generateRow.id)
        const rowInfo = this.selectTableData[rowIndex]
        rowInfo.offlinePackageStatus = 'PROCESSING'
        this.selectTableData.splice(rowIndex, 1, rowInfo)
        this.$tracks({
          event: 'exportOfflinePackage',
          params: { g_c_space_id: this.spaceId, g_c_file_id: this.generateRow.id, g_c_file_type: 'FILE' }
        })
      }).catch((err) => {
        this.$matchError(err.code, fileErrorCodeMap, '生成失败')
      })
    },
    // 下载离线包
    downloadOffline(row) {
      this.$api.file.getFileOfflinePackageUrl(this.spaceId, row.id, row.spaceFileRevisionId).then((res) => {
        if (this.clientType === 'web') {
          this.$downloadFile(res)
        } else {
          this.$desktopClient.NavigateToBrowser(res)
        }
        this.$tracks({
          event: 'downloadOfflinePackage',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: row.id,
            g_c_file_type: 'FILE'
          }
        })
      }).catch((err) => {
        this.$matchError(err.code, fileErrorCodeMap, '获取下载地址失败')
      })
    },

    getLevelFile (level) {
      return this.filePaths[this.filePaths.length - level] || this.fileTreeList[0]
    },
    getFilePath(node) {
      const activePath = node.path.split(',').map(Number)

      // 使用 reduce 方法来构建从根到当前节点的路径
      const filePath = activePath.reduce((acc, id) => {
        const item = this.folderData.find((item) => item.id === id)
        if (item) {
          acc.push(item)
        }
        return acc
      }, [])
      this.filePaths = filePath
      return filePath.map((item) => item.name).join('/')
    },
    // 批量操作- 下载
    async batchDownload() {
      // 文件批量下载，弹框评分
      this.checkFeedbackExists().catch()
      const operationKey = await this.getOperationKey(null, 'id')
      this.$api.file.batchDownload(this.spaceId, operationKey).then((res) => {
        if (res.length > 0) {
          if (this.clientType === 'web') {
            res.forEach((v) => {
              this.$downloadMultipleFile(v.downloadUrl, v.name)
            })
          } else {
            res.forEach((v) => {
              this.$desktopClient.NavigateToBrowser(v.downloadUrl)
            })
          }
          this.$tracks({
            event: 'downloadSpaceProfile',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: res.map((f) => f.id),
              g_c_batch: true,
              g_c_count: res.length
            }
          })
        }
      }).catch((err) => {
        if (err.code) {
          this.$message.error(batchDownloadErrorCodeMap[err.code])
        }
      }).finally((e) => {
        this.$fullLoading.close()
      })
    },
    // 打开弹框
    openClassifyDialog(row) {
      if (row.name) {
        this.typeName = '移动 ' + row.name + ' 到'
        // 获取当前选中ID
        this.spaceResourceId = row.id
      } else {
        this.typeName = '移动到'
      }

      this.showClassifyDialog = true
    },
    // 关闭弹框
    closeClassifyDialog() {
      this.showClassifyDialog = false
      this.batchClassifyValue = ''
    },
    // 目标节点选取
    chooseBatchClassify(value) {
      this.spaceCategoryIdMove = value?.id
      this.batchClassifyValue = value?.id
      this.batchClassifyValueDisable = false
    },
    // 移动
    async confirmModifyClassify() {
      // 批量移动
      this.spaceResourceId && this.selectionChange([{ id: this.spaceResourceId }])
      const operationKey = await this.getOperationKey(null, 'id')
      const params = {
        source_parent_id: this.currentCatalog.parentId || this.selectFolderId,
        target_parent_id: this.spaceCategoryIdMove,
      }
      this.$api.file.moveFile(this.spaceId, operationKey, params).then((res) => {
        this.$message.success(`移动成功`)
        this.$tracks({
          event: 'moveSpaceProfile',
          params: { g_c_space_id: this.spaceId, }
        })
        this.updateAllData()
        this.closeClassifyDialog()
        this.$fullLoading.close()
      }).catch((err) => {
        this.$matchError(err.code, moveErrorCodeMap, '移动失败')
      }).finally(() => {
        this.$fullLoading.close()
      })
    },
    // 批量删除
    async batchDeleteFiles() {
      try {
        const operationKey = await this.getOperationKey(null, 'id')
        this.$confirm(`是否确认删除 选中数据 ？<span style="color:#999;">(全部版本数据都将被一同删除)</span>`,
          {
            type: 'warning',
            dangerouslyUseHTMLString: true,
            confirmButtonClass: 'user-confirm',
            confirmButtonText: '确定删除'
          }).then(() => {
          this.$api.file.batchDeleteFiles(this.spaceId, operationKey).then((res) => {
            this.$fullLoading.close()
            this.$message.success('批量删除成功')
            this.$tracks({
              event: 'deleteSpaceProfile',
              params: { g_c_space_id: this.spaceId, }
            })
            this.updateAllData()
          }).catch((err) => {
            this.$matchError(err.code, batchDeleteErrorCodeMap, '批量删除失败')
          }).finally(() => {
            this.$fullLoading.close()
          })
        }).catch(() => {})
      } finally {
        this.$fullLoading.close()
      }
    },
    // 删除
    deleteFile(row, reload) {
      const tooltipText = row.isFolder ? `是否确定删除文件夹 <b>${row.name}</b> 及其下全部内容？` : `是否确定删除 <b>${row.name}.${row.suffix}</b> 的全部版本数据？`
      this.$confirm(tooltipText, {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'user-confirm',
        confirmButtonText: '确定删除',
      })
        .then(() => {
          this.$api.file.deleteFile(this.spaceId, row.id).then(() => {
            this.$message.success(`删除成功`)
            this.$tracks({
              event: 'deleteSpaceProfile',
              params: { g_c_space_id: this.spaceId, }
            })
            if (reload) {
              this.init()
              this.isFirstChange = true
              this.filePaths = []
              this.selectFolderId = this.fileTreeList[0]?.id
              this.spaceCategoryId = this.fileTreeList[0]?.id
            } else {
              this.updateAllData()
            }
          }).catch((err) => {
            this.$matchError(err.code, deleteErrorCodeMap, '删除失败')
          })
        })
        .catch(() => { })
    },
    // 下载
    toDownload(item) {
      if (item.downloadLoading) {
        return false
      }
      // 文件下载，弹框评分
      this.checkFeedbackExists()
      this.$api.file.versionRecordsDownload(this.spaceId, item.id).then((res) => {
        if (this.clientType === 'web') {
          this.$downloadFile(res)
        } else {
          this.$desktopClient.NavigateToBrowser(res)
        }
        this.$tracks({
          event: 'downloadSpaceProfile',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: item.id,
          }
        })
      }).catch((err) => {
        this.$matchError(err.code, downloadErrorCodeMap, '获取下载地址失败')
      }).finally((e) => {
        item.downloadLoading = false
      })
    },
    resetSelectedClassify() {
      this.softwareCategoryCode = null
      this.spaceCategoryId = null
    },
    rowClassName({ row }) {
      return this.newRows.some((item) => item.id === row.id) ? 'highlight-row' : ''
    },
    sortChange(sortObj) {
      const { order, prop } = sortObj
      const propMap = {
        name: 'NAME',
        createTime: 'CREATE_TIME',
        lastModifiedTime: 'UPDATE_TIME',
        fileType: 'FILE_TYPE'
      }

      const orderMap = {
        ascending: 'ASC',
        descending: 'DESC'
      }

      this.sortForm = {
        orderBy: propMap[prop],
        orderType: orderMap[order]
      }
      this.search({}, false, true)
    },
    rowDblclick(row) {
      this.isFirstChange = true
      if (row.isFolder) {
        this.searchForm = {}
        this.activeSearchName = ''
        this.selectFolderId = row.id
        this.spaceCategoryId = row.id
        !this.defaultKeyArr.includes(row.id) && this.defaultKeyArr.push(row.id)
        this.updateHighlightNode(this.selectFolderId)
        this.getList({ parentId: row.id })
        this.getFilePath(row)
      } else {
        this.showDataVersionRecord(row)
      }
    },
    keywordChange() {
      this.isFirstChange = true
      const activeLevel = this.getLevelFile(1)
      if (this.searchForm.keyword) {
        this.activeSearchName = activeLevel?.name || '全部文件'
        this.search({}, false, true)
      } else {
        this.quitSearchStatus(true)
      }
    },
    async handleRefresh(isTrack = false) {
      await this.search({}, false, isTrack)
      await this.getFolderData()
      this.$message.success('数据已刷新')
    },
    search(params = {}, isPolling = false, isTrack = false) {
      // 获取当前层级
      const activeLevel = this.getLevelFile(1)
      if (activeLevel) {
        if (isPolling) {
          this.getListForPolling({ parentId: activeLevel?.id, ...params })
        } else {
          this.getList({ parentId: activeLevel?.id, ...params }, isTrack)
        }
      } else {
        this.refresh(isPolling)
      }
    },
    async getFolderData(params = {}, isPolling = false) {
      // 更新数据时，取消编辑状态
      if (!isPolling) {
        this.resetModify()
      }
      await this.$api.file.getFilesList(this.spaceId, params).then((data) => {
        this.folderData = data.list.filter((item) => item.isFolder)
        this.fileTreeList = Utils.listToTree(this.folderData, false, 'id')
        this.updateHighlightNode(this.selectFolderId || this.fileTreeList[0]?.id)
        this.activePermissionType = this.fileTreeList[0].permissionType
      }).catch((err) => {
        if (!isPolling) {
          err?.code && this.$matchError(err.code, listErrorCodeMap)
        }
      })
    },
    async getList(params = {}, isTrack = false) {
      // 更新数据时，取消编辑状态
      this.resetModify()
      this.tableLoading = true
      const query = { fileTypes: this.selectSizerTags, ...this.searchForm, ...this.sortForm, ...params, }
      await this.$api.file.getFilesList(this.spaceId, query).then((data) => {
        if (data) {
          this.tableData = [...this.tableData, ...data.list.filter((item) => !this.tableData.find((existing) => existing.id === item.id))]
          this.selectTableData = data.list
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
          if (isTrack) {
            this.$tracks({
              event: 'querySpaceProfile',
              params: {
                g_c_space_id: this.spaceId,
                g_c_keyword: this.searchForm.keyword,
                g_c_folder_id: query.parentId,
                g_c_result_count: data.totalCount
              }
            })
          }
        }
      }).catch((err) => {
        this.$matchError(err.code, listErrorCodeMap)
      })
        .finally(() => {
          this.tableLoading = false
        })
    },
    // 轮询获取列表
    async getListForPolling(params = {}) {
      const query = { fileTypes: this.selectSizerTags, ...this.searchForm, ...this.sortForm, ...params, }
      await this.$api.file.getFilesList(this.spaceId, query).then((data) => {
        if (data) {
          this.tableData = [...this.tableData, ...data.list.filter((item) => !this.tableData.find((existing) => existing.id === item.id))]
          this.selectTableData = data.list
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
        }
      })
    },
    goToFolder(row) {
      this.selectFolderId = row.isFolder ? row.id : row.parentId
      this.updateHighlightNode(this.selectFolderId)
      this.getFilePath(row)
      this.quitSearchStatus()
      if (row.isFolder) {
        this.rowDblclick(row)
      }
    },
    // 更新高亮节点
    updateHighlightNode(id) {
      this.$nextTick(() => {
        this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(id)
        !this.defaultKeyArr.includes(this.fileTreeList[0]?.id) && this.defaultKeyArr.push(this.fileTreeList[0]?.id)
      })
    },
    quitSearchStatus(isTrack = false) {
      this.isFirstChange = true
      this.searchForm = {}
      this.activeSearchName = ''
      this.$refs.listTable?.$children[0].clearSort()
      this.search({}, false, isTrack)
    },
    async updateAllData() {
      await this.getFolderData()
      await this.search()
    },
    async refresh(isPolling = false) {
      this.filePaths = []
      this.tableData = []
      await this.getFolderData(isPolling)
      if (isPolling) {
        await this.getListForPolling()
      } else {
        await this.getList()
      }
    },
    // 修改之后重置
    resetModify() {
      this.modifyCol = ''
      this.modifyIndex = -1
      this.tempRow = {}
      this.startPolling(this.polling)
    },
    // 修改名称
    async modifyName(row, value) {
      if (row.name === value) {
        this.resetModify()
        return
      }
      if (RegSymbol.test(value)) {
        this.$message.error('名称中有禁止的特殊符号')
        return
      }
      await this.$api.file.renameFiles(this.spaceId, row.id, { name: value }).then((res) => {
        if (res === true) {
          this.$message.success(`修改成功`)
          if (row.isFolder) {
            this.$tracks({
              event: 'renameProfileFolder',
              params: { g_c_space_id: this.spaceId, }
            })
          } else {
            this.$tracks({
              event: 'renameSpaceProfile',
              params: { g_c_space_id: this.spaceId, }
            })
          }
          this.resetModify()
          this.updateAllData()
        }
      }).catch((err) => {
        const errors = {
          ...renameErrorCodeMap,
          'duplicate.name.error': row.isFolder ? '存在重名文件夹，请修改' : '存在重名文件，请修改',
        }
        this.$matchError(err.code, errors, '修改失败')
      })
    },
    // 点击构件名称 单元格时触发
    cellClick(row, index, colName) {
      this.stopPolling()
      this.modifyCol = colName
      this.modifyIndex = index
      this.tempRow = { ...row }
      this.$nextTick(() => {
        switch (colName) {
          case 'name':
            this.$refs.editName.toFocus()
            break
        }
      })
    },
    // 点击上传
    async showUploader(operateType) {
      // 文件上传，弹框评分
      this.checkFeedbackExists().catch()
      await this.$api.file.getFilePath(this.spaceId, this.selectFolderId)
      this.$refs.uploader.showModal(operateType)
    },
    async onRenewal(row, operateType) {
      console.info('on entering renewal')
      // 文件更新，弹框评分
      this.checkFeedbackExists().catch()
      const data = await this.$api.file.enableRevision(this.spaceId, row.id)
      if (data.bimfaceTranslateStatus === 'PROCESSING') {
        // 转换中
        this.$confirm('当前版本正在进行轻量化转换，更新后转换将继续进行，若需查看请至版本管理。', {
          cancelButtonText: '取消更新',
          confirmButtonText: '继续',
          showClose: false,
          customClass: 'message-box-class',
          iconClass: 'el-icon-warning'
        }).then(() => {
          this.renewalObj = row
          this.renewalObj.spaceId = this.spaceId
          this.$refs.uploader.triggerUpload(operateType, row)
        }).catch(() => {
          if (this.canEmitWebEventToDesktop) {
            this.$desktopClient.EmitWebEvent({
              eventName: 'file-renewal-finish',
              eventArgs: JSON.stringify({
                success: false,
                message: 'user canceled because of processing bimface translate'
              })
            })
          }
        })
      } else if (data.bimfaceTranslateStatus === 'SUCCESS') {
        // 转换成功
        this.$confirm(`温馨提醒：<br/>
                      1、文件更新后需要重新转换轻量化模型；<br/>
                      2、若需查看旧版本轻量化模型请至版本管理中查看；<br/>
                      3、更新成功后，该文件的轻量化模型<em>分享链接将失效</em>，若需分享请至版本管理中启用旧版本。`, {
          cancelButtonText: '取消更新',
          confirmButtonText: '继续',
          dangerouslyUseHTMLString: true,
          showClose: false,
          customClass: 'message-box-class',
          iconClass: 'el-icon-warning'
        }).then(() => {
          this.renewalObj = row
          this.renewalObj.spaceId = this.spaceId
          this.$refs.uploader.triggerUpload(operateType, row)
        }).catch(() => {
          if (this.canEmitWebEventToDesktop) {
            this.$desktopClient.EmitWebEvent({
              eventName: 'file-renewal-finish',
              eventArgs: JSON.stringify({
                success: false,
                message: 'user canceled because of processed bimface translate'
              })
            })
          }
        })
      } else {
        this.renewalObj = row
        this.renewalObj.spaceId = this.spaceId
        this.$refs.uploader.triggerUpload(operateType, row)
      }
    },
    async onLink(row) {
      // 文件链接，弹框评分
      this.checkFeedbackExists().catch()
      if (this.canUpdateCachePath) {
        // 校正缓存路径
        await this.$desktopClient.RectifyJunction(businessBasePath(), this.pluginCachePath)
        await this.startLink(row)
      } else {
        await this.startLink(row)
      }
    },
    startLink(row) {
      if (this.clientType === 'g' && !this.isCapitalSoftware) {
        const architectureUsableFileTypes = ['GAP', 'GMEPC', 'GSTC', 'IFC', 'IFCZIP']
        const structureUsableFileTypes = ['GST', 'GAPC', 'GMEPC', 'IFC', 'IFCZIP']
        const electricalUsableFileTypes = ['GAPC', 'GMEP', 'GSTC', 'IFC', 'IFCZIP']
        let isFileTypeUsable = false // 标记文件是否可用
        switch (this.clientTypeSoftwareCode) {
          case 'AppGarch':
            isFileTypeUsable = architectureUsableFileTypes.includes(row.fileType)
            break
          case 'AppGstr':
            isFileTypeUsable = structureUsableFileTypes.includes(row.fileType)
            break
          case 'AppGmep':
            isFileTypeUsable = electricalUsableFileTypes.includes(row.fileType)
            break
        }
        if (!isFileTypeUsable) {
          this.$message.error('不支持的文件格式')
          return
        }
      }
      // 如果文件类型可用，则执行以下逻辑
      if (row.fileType === 'DWG' || row.fileType === 'DXF') {
        this.$refs.revitLinkCAD && this.$refs.revitLinkCAD.onRevitLink(row)
      } else if (row.fileType === 'IFC' || row.fileType === 'IFCZIP') {
        const title = '链接ifc'
        this.$refs.linkIFC && this.$refs.linkIFC.onLink(row, title)
      } else {
        const title = row.fileType === 'RVT' ? '链接Revit' : '链接模型'
        this.$refs.revitLinkRVT && this.$refs.revitLinkRVT.onRevitLink(row, title)
      }
    },
    async onImport(row) {
      // 文件导入，弹框评分
      this.checkFeedbackExists().catch()
      if (this.canUpdateCachePath) {
        // 校正缓存路径
        await this.$desktopClient.RectifyJunction(businessBasePath(), this.pluginCachePath)
        await this.startImport(row)
      } else {
        await this.startImport(row)
      }
    },
    async startImport(row) {
      const result = await this.$desktopClient.GetActiveView()
      if (result.data?.viewType === 'Drawing') {
        this.$message.error('图纸视图不可导入，请切换到其他视图后操作')
        return
      }
      if (this.clientType === 'r') {
        await this.$refs.revitImport?.onRevitImport(row)
      } else if (this.clientType === 'g') {
        await this.$refs.gImport?.onRevitImport(row)
      }
    },
    allowFileType() {
      const types = getFileTypes('FILE', null) || []
      return types.join(',')
    },
    // 秒传/上传后的回调
    uploadCallback({ file, id }) {
      this.$refs.uploader.updateFile(file, { uploadProgress: 100 })
      if (file.operate === 'upload') {
        this.crQueue.preDo({ file, id })
      } else {
        // 替换
        this.reQueue.preDo({ file, id })
      }
    },
    // 创建新文件
    createNewFile({ file, id }) {
      const params = {
        md5: file.md5,
        name: file.name,
        parentId: file.spaceCategoryId, // 父文件夹ID
        storeId: id,
        isFolder: false,
      }
      this.$api.file.createFile(this.spaceId, params).then((res) => {
        if (res === true) {
          // 根据接口返回增加一种字段 更新成功 updateSuccess
          const uploadStatus = 'success'
          this.$tracks({
            event: 'uploadSpaceProfile',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_format: file.name.split('.').slice(-1)
            }
          })
          this.$refs.uploader.updateFile(file, { uploadStatus, uploadProgress: 100 })
          this.search()
        }
      }).catch((err) => {
        let uploadStatus = 'fail'
        if (['duplicate.name.error', 'resource.name.already.existed', 'resource.md5.already.existed'].includes(err.code)) {
          uploadStatus = 'fileExisted'
        }
        this.$refs.uploader.updateFile(file, { uploadStatus: uploadStatus })
      }).finally(() => {
        this.crQueue.nextDo()
      })
    },
    // 更新文件
    renewalFile({ file, id }) {
      const params = {
        name: file.name,
        md5: file.md5,
        storeId: id,
      }
      this.$api.file.renewalFile(this.spaceId, file.id, params).then((res) => {
        if (res === true) {
          this.$tracks({
            event: 'updateSpaceProfile',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: file.id,
              g_c_file_format: file.suffix || file.name.split('.')[1],
              g_c_file_size: file.size
            }
          })
          this.$refs.uploader.updateFile(file, { uploadStatus: 'success', uploadProgress: 100 })
          this.search()
        }
        if (this.canEmitWebEventToDesktop) {
          this.$desktopClient.EmitWebEvent({
            eventName: 'file-renewal-finish',
            eventArgs: JSON.stringify({
              success: res === true,
              message: res === true ? '' : 'res is not true'
            })
          })
        }
      }).catch((err) => {
        if (err.code === 'resource.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'md5Duplicate' })
          this.$message.error('与当前文件重复，无需更新')
        } else if (err.code === 'file.not.exist') {
          this.$message.error('文件不存在')
        } else if (err.code === 'resource.mismatch') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'versionMismatch' })
        } else if (err.code === 'space.resource.software.version.not.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'notExisted' })
        } else {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'fail' })
        }
        if (this.canEmitWebEventToDesktop) {
          this.$desktopClient.EmitWebEvent({
            eventName: 'file-renewal-finish',
            eventArgs: JSON.stringify({
              success: false,
              message: err.code
            })
          })
        }
      }).finally(() => {
        this.reQueue.nextDo()
      })
    },
    toCreatePlan() {
      this.$refs.CreateEditPlanDialog?.openDialog()
    },
    toViewPlan() {
      // 文件更新，弹框评分
      this.checkFeedbackExists()
      this.$router.push({ name: 'FederationPlanList', params: { spaceId: this.spaceId }})
    },
    async polling() {
      await this.search({}, true)
      await this.getFolderData({}, true)
    },
  },
}
</script>

<style lang="less" scoped>
.search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  >div:first-child {
    display: flex;
    align-items: center;
  }
  .logo-img {
    width: 18px;
    height: 21px;
    margin: 0 -16px 0 16px;
  }
}

.confirm-main{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  .confirm-icon{
    font-size: 20px;
    margin-right: 16px;
  }
  .main-text{
    font-size: 16px;
    margin-bottom: 12px;
  }
  .sub-text{
    color: rgba(0, 0, 0, .4);
  }
}
.model-status{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .offline-status{
    margin-left: 8px;
    margin-top: 2px;
  }
  .ft-icon{
    font-size: 18px;
  }
}

.sizer-view-container {
  padding: 0 16px 16px;
  line-height: 40px;
  >span{
    color: @text-tag-gery;
    &:hover {
      cursor: pointer;
      color: @theme-color;
    }
  }
}

.flex-1 {
  height: calc(100vh - 90px);
}

.folder-catalog {
  max-height: calc(100vh - 100px);
}

.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 16px;
  .sizer-btn {
    margin-left: 10px;
  }
}

.batch-button-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.sizer-btn-group {
  text-align: right;
  margin: 15px 0 0 0;
  display: flex;
  justify-content: space-between;
  >div:last-child {
    display: flex;
  }
}

.el-tag {
  background: @bg-grey-light-2;
  box-sizing: border-box;
  border: 1px solid @border-color-tag;
  color: @text-tag-gery;
  margin-right: 6px;
}

.sizer-content {
  display: flex;
  padding: 10px 0;
  .label-content {
    flex: 0 0 56px;
  }
  .sizer-main-content{
    flex: 1;
  }
  .el-tag {
    margin-top: 8px;
  }
}

.sizer-box {
  position: relative;
  top: -8px;
  .el-tag {
    &:hover {
      cursor: pointer;
      background: @bg-grey-light-active-2;
      border-color: @border-color-active-tag;
      color: @text-tag-active-gery;
    }
  }
}

.active-tag {
  background: @bg-grey-light-active-2;
  border-color: @border-color-active-tag;
  color: @text-tag-active-gery;
}

/deep/.el-table__header {
  background-color: grey;
}

.delete {
  color: red;
}

.delete:hover {
  color: #fff;
  background: red;
}

.el-dropdown-menu {
  min-width: 80px;
  border-radius: 2px;
  padding: 4px 0;
  text-align: center;
}

.green {
  background: #fafafa;
  border: 1px solid #b7eb8f;
}

.red {
  background: #fff1f0;
  border: 1px solid #ffa39e;
}

.el-tree {
  margin-left: 2px;
}

.component-uploader {
  position: fixed;
  bottom: 0;
  z-index: 999;
}

.btn-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  /deep/ .el-button-group {
    line-height: unset;
  }

  .el-button {
    margin-right: 4px;
  }

  .operations-left {
    margin-right: 12px;
  }

  .el-dropdown-link {
    display: inline-block;
    padding: 0 15px;
    font-size: 12px;
    font-weight: 500;
    height: 30px;
    line-height: 30px;
    border: 1px solid @border-color;
    border-radius: 0 4px 4px 0;
  }

  .delete-button:hover,
  .delete-button:focus,
  .delete-button:active {
    background: #fff;
    border-color: red;
    color: red;
  }
}

.keyword-input {
  width: 200px;
}

.btn-right {
  color: rgba(73, 95, 112, 0.6);
  font-size: 12px;
}

.full-file-paths {
  cursor: pointer;
  color: @theme-color;
  width: 100%;
  display: inline-block;
}
.name-click{
  cursor: pointer;
  color: @theme-color;
  &:hover{
    text-decoration: underline;
  }
}
.table-name {
  img {
    position: relative;
    top: 5px;
  }
}
.folder-img, .file-img {
  width: 20px;
  height: 20px;
}

/deep/ .right-part {
  width: 1px;
  height: calc(100vh - 112px);
}

/deep/ .el-table .el-table__body-wrapper {
  max-height: calc(100% - 51px);
}

/deep/ .el-table__row {
  cursor: pointer;
}

/deep/ .el-breadcrumb {
  display: flex;
  align-items: baseline;
  .return-to-upper-level {
    cursor: pointer;
    color: @color-text-breadcrumb;
    &:hover {
      color: @color-text-breadcrumb-hover;
    }
  }
  i {
    margin-right: 2px;
  }
  .el-breadcrumb__item:last-child {
    >span {
      color: @color-text-breadcrumb-hover;
    }
  }
}

/deep/ .highlight-row {
  .el-table__cell:first-child {
    border-left: 1px solid @theme-color;
  }
  .el-table__cell:last-child {
    border-right: 1px solid @theme-color;
  }
  .el-table__cell {
    background: none !important;
    border-top: 1px solid @theme-color;
    border-bottom: 1px solid @theme-color;
  }
}
.drop-down{
  position: relative;
  height: 100%;
  width: 100%;
  .drop-down-menu{
    position: absolute;
    bottom: 0;
    left:0;
    z-index: 99;
    background: #fff;
    display: none;
  }
  &.drop-down-hover{
    .drop-down-menu{
      display: block;
    }
  }
}
.link-content{
  display: flex;
  align-items: center;
}
.model-body{
  padding: 20px 20px 20px 24px;
  .content-line{
    line-height: 32px;
  }
}
.version-tag{
  padding: 1px 8px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  background: #FAFAFA;
  margin-left: 8px;
}
.tip-line{
  background: #E6F7FF;
  border: 1px solid #91D5FF;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
}
.table-cell-icon{
  position: absolute;
  right: 0;
  top: 8px;
  margin-left: 4px;
  font-size: 18px;
  color: @text-tag-gery;
}
</style>
